import script from "./Terms.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms.vue?vue&type=script&setup=true&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=fe819a0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe819a0e"]])

export default __exports__